const module = { name: 'theater/shared/locationHelpers', exports: {} }; const exports = module.exports;



import { Fandango_sanitizer as sanitizer } from 'require-core';



import { default as countrySwitcher } from 'swug-fdRequire-call:fd-location/countrySwitcher';



const RegExes = {
    DASH: /-/g,
    IS_POSTAL: /^(\d{5}(?:[-\s]\d{4})?|[A-Za-z]{1,2}\d[A-Za-z\d]?(?:[-\s]?\d[A-Za-z]{2})?)$/,
}


const CountriesWithKm = ['IE']
function parsePath(path) {
    return sanitizer.text(decodeURIComponent(path.split(/_movietimes/i).shift().substring(1)));
}
function getLocationFromURL(path) {
    const location = {};
    const urlLocation = parsePath(path);
    const segments = urlLocation.split('_');
    if (segments.length === 3 && segments[2].length === 2) {
        const firstSegment = segments[0].replace(RegExes.DASH, ' ');
        if (RegExes.IS_POSTAL.test(firstSegment)) {
            location.postalCode = firstSegment;
        }
        else {
            location.city = firstSegment.toLowerCase();
        }
        location.region = segments[1].replace(RegExes.DASH, ' ');
        location.country = segments[2].toUpperCase();
    }
    else if (segments.length === 2 && segments[1].length === 2) {
        location.postalCode = segments[0].replace(RegExes.DASH, ' ');
        location.country = segments[1].toUpperCase();
    }
    else if (RegExes.IS_POSTAL.test(urlLocation)) {
        location.postalCode = urlLocation.replace(RegExes.DASH, ' ');
    }
    else if (segments.length >= 2) {
        location.city = segments[0].replace(RegExes.DASH, ' ').toLowerCase();
        location.region = segments[1].replace(RegExes.DASH, '');
    }
    return location;
}
function convertMiToKm(mi) {
    return mi && !isNaN(mi) ? parseFloat((mi * 1.60934)) : null;
}
function formatTheaterDistance(theater, maximumFractionDigits = 1, narrow = false) {
    if (theater.distance && !isNaN(theater.distance) && theater.distance > 0) {
        const countryCode = countrySwitcher.getCurrentCountry();
        const usesKm = CountriesWithKm.includes(countryCode);
        theater.distance = usesKm ? convertMiToKm(theater.distance) : theater.distance;
        theater.formattedDistance = new Intl.NumberFormat(navigator.language, {
            style: 'unit',
            unit: usesKm ? 'kilometer' : 'mile',
            maximumFractionDigits,
            unitDisplay: narrow ? 'narrow' : 'short'
        }).format(theater.distance);
    }
    else {
        theater.formattedDistance = null;
    }
}
module.exports = {
    formatTheaterDistance,
    getLocationFromURL,
};
export default module.exports;